import * as React from 'react';

import {PopoverInfo} from '../../popover-info/popover-info';

type Props = {
    title: string;
    infoText: string;
};

export function HeaderWithInfo(props: Props) {
    return (
        <div className='flex align-center'>
            {props.title} <PopoverInfo size={14} bodyColor='dark' info={props.infoText} />
        </div>
    );
}
